module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/elo-124c907517df310453c7a57924536e78.svg";